import { useEffect, useRef, useState } from "react";
import { post } from "../js/post";
import { invoiceDeliveryNotesSearcherColumns } from "../js/tableColumns";
import { userData, formatValueUnit } from "../js/utils";
import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import DropdownFilter from "./DropdownFilter";
import CheckBox from "./CheckBox";
import moment from "moment";

export default function InvoiceDeliveryNotesSearcher({
  supplier,
  onAdd,
  onClose,
}) {
  const [deliveryNotesList, setDeliveryNotesList] = useState([]);
  const [deliveryNotesListFixed, setDeliveryNotesListFixed] = useState([]);
  const [searchData, setSearchData] = useState({
    number: "",
    startDate: "",
    endDate: "",
    creationStartDate: "",
    creationEndDate: "",
    start: 0,
  });
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(25);
  const [selectedDNList, setSelectedDNList] = useState([]);
  const popupRef = useRef(null);

  const inputOnEnterScoped = (e) => {
    if (e.keyCode !== 13) return;
    const inputs = Array.from(
      popupRef.current?.querySelectorAll("input, textarea") ?? [],
    )
      .filter(
        (el) => el.tabIndex > 0 && !el.disabled && el.offsetParent !== null,
      )
      .sort((a, b) => a.tabIndex - b.tabIndex);
    const currentIndex = inputs.indexOf(document.activeElement);
    if (currentIndex !== -1) {
      const next = inputs[(currentIndex + 1) % inputs.length];
      next?.focus();
      next?.select();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Tab") return;
      const focusable = Array.from(
        popupRef.current?.querySelectorAll(
          'input:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ) ?? [],
      ).filter((el) => el.offsetParent !== null);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // console.log("deliveryNotesList: ", deliveryNotesList);
  // console.log("deliveryNotesListFixed: ", deliveryNotesListFixed);

  const updatedColumns = invoiceDeliveryNotesSearcherColumns.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        selector: (row) => (
          <CheckBox
            active={selectedDNList.some((dn) => dn.id === row.id)}
            onClick={() => {
              selectedDN(row);
            }}
          />
        ),
      };
    }

    return col;
  });

  const selectedDN = (row) => {
    setSelectedDNList((prev) =>
      prev.some((dn) => dn.id === row.id)
        ? prev.filter((dn) => dn.id !== row.id)
        : [...prev, row],
    );
  };

  const handleSelectAll = () => {
    setSelectedDNList((prev) => [
      ...prev,
      ...deliveryNotesListFixed.filter(
        (dn) => !prev.some((selected) => selected.id === dn.id),
      ),
    ]);
  };

  const handleCleanSelected = () => {
    setSelectedDNList([]);
  };

  function resetFilters() {
    setSearchData({
      number: "",
      startDate: "",
      endDate: "",
      start: 0,
    });
  }

  async function getDeliveryNoteList() {
    const response = await post("support-extra/albaran/ListarAlbaranes.php", {
      token: userData.token,
      numAlbaranFact: searchData.number,
      fechaAlbaranDesde: searchData.startDate,
      fechaAlbaranHasta: searchData.endDate,
      fechaCompraDesde: "",
      fechaCompraHasta: "",
      fechaCreacionDesde: searchData.creationStartDate,
      fechaCreacionHasta: searchData.creationEndDate,
      familia: [],
      nombreProveedor: supplier,
      codigo: "",
      estadoBorrador: 2,
      start: searchData.start,
      total: limit,
    });
    // console.log(
      // "LISTANDO ALBARANES: ",
      // {
        // token: userData.token,
        // numAlbaranFact: searchData.number,
        // fechaAlbaranDesde: searchData.startDate,
        // fechaAlbaranHasta: searchData.endDate,
        // fechaCompraDesde: "",
        // fechaCompraHasta: "",
        // fechaCreacionDesde: searchData.creationStartDate,
        // fechaCreacionHasta: searchData.creationEndDate,
        // familia: [],
        // nombreProveedor: supplier,
        // codigo: "",
        // estadoBorrador: 2,
        // start: searchData.start,
        // total: limit,
      // },
      // response,
    // );
    setTotal(response.totalAlbaranes);
    const filtered = response.albaranes.filter((a) => !a.facturado);
    if (searchData.start === 0) {
      setDeliveryNotesList(filtered);
      setDeliveryNotesListFixed(filtered);
    } else {
      setDeliveryNotesList([...deliveryNotesList, ...filtered]);
      setDeliveryNotesListFixed([...deliveryNotesList, ...filtered]);
    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getDeliveryNoteList();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchData, limit]);

  return (
    <div className="popup-container" style={{ zIndex: 20 }}>
      <div
        className="ap-container popup-screen"
        style={{ zIndex: 20 }}
        ref={popupRef}
      >
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Albaranes</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              onClose();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="store-products-table delivery-note-table"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
            padding: 10,
          }}
        >
          <div className="container-panel">
            <div
              className="opt-table-title"
              style={{ justifyContent: "space-between" }}
            >
              <span>Búsqueda de albarán</span>
              <button
                className="cell-label"
                onClick={resetFilters}
                tabIndex={-1}
              >
                Limpiar filtros
              </button>
            </div>
            <div
              className="opt-table-content grid-8"
              id="delivery-note-invoice-filters-grid"
              style={{ marginTop: 20 }}
            >
              <div className="cell cell-start-content data-field">
                <span className="label">Nº albarán</span>
              </div>
              <div className="cell">
                <InputData
                  tabIndex={31}
                  type="type-alphanum-ext"
                  size={0}
                  input={searchData.number}
                  onChange={(e) => {
                    setSearchData((prev) => ({
                      ...prev,
                      number: e,
                    }));
                  }}
                ></InputData>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content data-field">
                <span className="label">Fecha albarán desde</span>
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={32}
                  className="input-field input-cell w-100"
                  value={searchData.startDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      startDate: value
                        ? moment(value).format("YYYY-MM-DD")
                        : "",
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnterScoped(e)}
                ></input>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content data-field">
                <span className="label">Fecha creación desde</span>
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={34}
                  className="input-field input-cell w-100"
                  value={searchData.creationStartDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      creationStartDate: value
                        ? moment(value).format("YYYY-MM-DD")
                        : "",
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnterScoped(e)}
                ></input>
              </div>
              <div className="cell combined-cells-3"></div>
              <div className="cell cell-start-content data-field">
                <span className="label">Fecha albarán hasta</span>
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={33}
                  className="input-field input-cell w-100"
                  value={searchData.endDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      endDate: value ? moment(value).format("YYYY-MM-DD") : "",
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnterScoped(e)}
                ></input>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content data-field">
                <span className="label">Fecha creación hasta</span>
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={35}
                  className="input-field input-cell w-100"
                  value={searchData.creationEndDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      creationEndDate: value
                        ? moment(value).format("YYYY-MM-DD")
                        : "",
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnterScoped(e)}
                ></input>
              </div>
            </div>
          </div>
          <div
            className="container-panel invoice-db-searcher"
            style={{ width: "100%" }}
          >
            <div className="opt-table-title opt-table-title-button">
              <div>
                Listado de albaranes (
                {formatValueUnit(deliveryNotesListFixed.length)})
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 30 }}>
                <DropdownFilter
                  disabled={false}
                  optionList={[
                    { id: "00", text: "25", active: limit === 25 },
                    { id: "01", text: "50", active: limit === 50 },
                    { id: "02", text: "100", active: limit === 100 },
                  ]}
                  op={"Mostrando " + limit}
                  selectedOptions={[]}
                  onChange={(e) => {
                    setLimit(parseInt(e.text));
                    setSearchData((prev) => ({
                      ...prev,
                      start: 0,
                    }));
                  }}
                ></DropdownFilter>
              </div>
            </div>
            {deliveryNotesListFixed.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 10,
                  marginBottom: 5,
                }}
              >
                <button
                  className="cell-label"
                  onClick={handleSelectAll}
                  tabIndex={-1}
                >
                  Seleccionar todos
                </button>
                |
                <button
                  className="cell-label"
                  onClick={handleCleanSelected}
                  tabIndex={-1}
                >
                  Limpiar selección
                </button>
              </div>
            )}
            <DataTable
              columns={updatedColumns}
              data={deliveryNotesListFixed}
              className="custom-datatable"
              noDataComponent="No hay albaranes disponibles."
              onRowClicked={(row, event) => {
                selectedDN(row);
              }}
            />
            {deliveryNotesListFixed.length > 0 && (
              <div className="popup-buttons" style={{ marginTop: 10 }}>
                <ButtonIconH
                  text="Ver más"
                  small={true}
                  disabled={deliveryNotesListFixed.length === total}
                  onClick={() => {
                    setSearchData((prev) => ({
                      ...prev,
                      start: prev.start + limit,
                    }));
                  }}
                ></ButtonIconH>
              </div>
            )}
          </div>
          {deliveryNotesListFixed.length > 0 && (
            <div
              className="container-panel"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ButtonIconH
                text="Añadir seleccionados"
                small={true}
                disabled={selectedDNList.length === 0}
                onClick={() => {
                  onAdd(selectedDNList);
                }}
              ></ButtonIconH>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
